import React from "react";
import { Button } from "semantic-ui-react";
import cx from "classnames";

import styles from "./save.module.scss";

export default function SaveChanges(props) {
  return (
    <>
      <Button
        type={props.type}
        onClick={props.onClick}
        content={props.content ? props.content : "Save Changes"}
        className={props.className ? props.className : cx(styles.btn)}
        disabled={props.disabled ? props.disabled : false}
      />
    </>
  );
}
